export interface ArticleData {
  id: number;
  title: string;
  category: string;
  platform: string;
  rating: number;
  year: number;
  updateInfo: string;
  imageSeq: string;
  content: string;
  tags: string[];
  relatedIds: number[];
}

export const articles: Record<number, ArticleData> = {
  1: {
    id: 1,
    title: '暑期档热映大片《龙马精神》',
    category: '电影',
    platform: '芒果视频',
    rating: 8.5,
    year: 2025,
    updateInfo: 'HD高清',
    imageSeq: 'movie-ride-on',
    content: `<p>《龙马精神》是由成龙领衔主演的一部温情动作电影。影片讲述了落魄的龙虎武师老罗与他的爱马"赤兔"之间的感人故事。</p><p>老罗曾经是香港电影黄金时代最出色的龙虎武师之一，如今年事已高，生活拮据，但他依然坚守着龙虎武师的精神。他与爱马赤兔相依为命，在一次意外中，他结识了年轻一代的电影人。</p><p>影片通过老罗的故事，向香港动作电影的黄金时代致敬，同时也展现了龙虎武师这一特殊职业群体的生存状态和精神追求。成龙在片中的表演真挚动人，既有令人热血沸腾的动作场面，也有催人泪下的温情时刻。</p><p>这部电影不仅是对香港动作电影的一次深情回望，更是对"龙马精神"这一中华民族传统美德的礼赞。影片上映后获得了观众和影评人的一致好评，被誉为近年来成龙最具诚意的作品之一。</p>`,
    tags: ['成龙', '动作', '温情', '龙虎武师', '香港电影'],
    relatedIds: [4, 9, 202, 204],
  },
  2: {
    id: 2,
    title: '《乘风破浪的姐姐》第六季',
    category: '综艺',
    platform: '芒果视频',
    rating: 8.6,
    year: 2026,
    updateInfo: '更新至第6期',
    imageSeq: 'variety-sisters-6',
    content: `<p>《乘风破浪的姐姐》第六季重磅回归！本季节目汇聚了来自演艺圈、音乐界、体育界等不同领域的三十位优秀女性，她们将在舞台上展现成熟女性的独特魅力与无限可能。</p><p>本季节目在赛制上进行了全新升级，增加了更多团队协作和个人挑战的环节。姐姐们不仅要在舞台上展现唱跳实力，更要在幕后展现团队精神和领导力。</p><p>节目播出以来，收视率一路攀升，多次登上热搜榜首。观众们被姐姐们的拼搏精神和对舞台的热爱所打动，纷纷表示"这才是真正的女性力量"。</p><p>本季节目还邀请了重量级嘉宾助阵，包括知名音乐制作人和舞蹈编导，为姐姐们的舞台表演提供专业指导。让我们一起期待姐姐们在剩余赛程中的精彩表现！</p>`,
    tags: ['乘风破浪的姐姐', '女性力量', '综艺', '芒果视频', '音乐竞技'],
    relatedIds: [6, 10, 402, 403],
  },
  3: {
    id: 3,
    title: '《风起洛阳》重磅回归',
    category: '电视剧',
    platform: '西瓜视频免费',
    rating: 8.9,
    year: 2026,
    updateInfo: '全40集',
    imageSeq: 'tv-wind-rises-luoyang',
    content: `<p>《风起洛阳》是由黄轩、王一博、宋茜领衔主演的古装悬疑大剧。故事背景设定在盛唐时期的神都洛阳，讲述了高秉烛、百里弘毅和武思月三人联手破获一系列离奇案件的故事。</p><p>剧集制作精良，无论是场景搭建还是服装道具，都力求还原盛唐时期洛阳城的繁华景象。悬疑氛围营造出色，每个案件都环环相扣，让观众欲罢不能。</p><p>黄轩饰演的高秉烛机智果敢，王一博饰演的百里弘毅温润儒雅，宋茜饰演的武思月飒爽英姿，三位主演的精彩演绎为剧集增色不少。配角阵容同样强大，众多实力派演员的加盟使得整部剧的表演水准极高。</p><p>该剧播出后口碑持续走高，豆瓣评分稳定在8.9分，被誉为"近年最佳古装悬疑剧"。观众们称赞其剧情紧凑、推理严谨、画面精美，是一部值得反复观看的佳作。</p>`,
    tags: ['黄轩', '王一博', '古装悬疑', '大唐', '洛阳'],
    relatedIds: [5, 8, 302, 305],
  },
  4: {
    id: 4,
    title: '流浪地球3',
    category: '电影',
    platform: '西瓜视频免费',
    rating: 9.2,
    year: 2026,
    updateInfo: 'HD高清',
    imageSeq: 'movie-wandering-earth-3',
    content: `<p>《流浪地球3》是中国科幻电影的又一座里程碑。本作延续前两部的宏大叙事，讲述了太阳急速老化膨胀，人类面临前所未有的生存危机，全球联合政府启动了"流浪地球计划"的第三阶段。</p><p>在这一部中，地球已经航行至太阳系边缘，人类面临着来自宇宙深处的全新威胁。影片的特效场面全面升级，将中国科幻电影的工业水准推向了新的高度。</p><p>导演郭帆再次用他独特的视角，将中国式的家国情怀与硬核科幻完美融合。影片不仅有震撼的视觉奇观，更有着触动人心的人文关怀。</p><p>上映以来，《流浪地球3》刷新了多项票房纪录，被国内外媒体广泛报道，成为中国科幻电影走向世界的标志性作品。</p>`,
    tags: ['科幻', '吴京', '郭帆', '流浪地球', '国产大片'],
    relatedIds: [1, 9, 201, 204],
  },
  5: {
    id: 5,
    title: '繁花',
    category: '电视剧',
    platform: '芒果视频',
    rating: 9.5,
    year: 2024,
    updateInfo: '全30集',
    imageSeq: 'tv-fanhua',
    content: `<p>《繁花》是由王家卫执导的首部电视剧作品，改编自金宇澄同名小说。该剧以上世纪九十年代的上海为背景，讲述了阿宝在时代浪潮中崛起的故事。</p><p>胡歌饰演的阿宝，从一个默默无闻的年轻人，在改革开放的大潮中逐渐成长为商界精英。剧中细腻地描绘了那个激情燃烧的年代里，人与人之间的真情与博弈。</p><p>王家卫独特的视觉风格在剧中得到了充分体现，每一帧画面都如同精美的摄影作品。上海话对白的使用更是让整部剧充满了浓郁的地域特色和年代感。</p><p>《繁花》播出后引发了广泛的社会讨论，收视率和口碑双双登顶。它不仅是一部优秀的电视剧作品，更是一个时代的缩影，让观众在欣赏精彩故事的同时，也感受到了时代的变迁。</p>`,
    tags: ['王家卫', '胡歌', '上海', '九十年代', '商战'],
    relatedIds: [3, 8, 301, 304],
  },
  6: {
    id: 6,
    title: '奔跑吧兄弟第十二季',
    category: '综艺',
    platform: '小蓝视频',
    rating: 8.8,
    year: 2026,
    updateInfo: '更新至第8期',
    imageSeq: 'variety-running-man',
    content: `<p>《奔跑吧兄弟》第十二季全新出发！本季跑男团阵容焕新，新老成员碰撞出全新的火花，为观众带来了更加精彩的户外竞技体验。</p><p>本季节目在游戏设计上更加注重创意与趣味性，每一期的主题都精心策划，从城市探秘到自然冒险，从历史文化到科技未来，让观众在欢笑中也能收获知识。</p><p>节目组特别邀请了多位当红明星作为飞行嘉宾，与跑男团一起完成各种挑战任务。嘉宾之间的互动自然有趣，笑点密集。</p><p>《奔跑吧兄弟》已经陪伴观众走过了十二年，依然保持着旺盛的生命力和创新精神。本季节目收视率持续走高，证明了这档经典综艺的持久魅力。</p>`,
    tags: ['奔跑吧兄弟', '户外竞技', '综艺', '小蓝视频', '真人秀'],
    relatedIds: [2, 10, 401, 404],
  },
  7: {
    id: 7,
    title: '哪吒之魔童闹海',
    category: '动漫',
    platform: '茄子视频',
    rating: 9.6,
    year: 2025,
    updateInfo: 'HD高清',
    imageSeq: 'anime-nezha-2',
    content: `<p>《哪吒之魔童闹海》是继《哪吒之魔童降世》之后的又一部国产动画巨制。影片讲述了哪吒与敖丙在天劫之后的重生故事。</p><p>本作的视觉效果在前作基础上全面升级，海底世界的构建美轮美奂，战斗场面的设计更是令人叹为观止。中国传统文化元素与现代动画技术的完美融合，让每一帧画面都充满了东方美学的韵味。</p><p>故事层面，影片深入探讨了命运、成长与责任的主题。哪吒在经历了生死考验后，对自我和世界的认知有了新的变化。他与敖丙从对手到战友的关系转变，也被刻画得细腻动人。</p><p>该片上映后不仅在国内取得了惊人的票房成绩，在海外市场也获得了广泛好评，让世界看到了中国动画的无限潜力。</p>`,
    tags: ['哪吒', '国产动画', '神话', '封神', '动漫电影'],
    relatedIds: [11, 501, 502],
  },
};

export function getArticleById(id: number): ArticleData | undefined {
  return articles[id];
}

export function getRelatedArticles(ids: number[]): ArticleData[] {
  return ids.map((id) => articles[id]).filter(Boolean);
}